/** @module SiteAdmin/SelectSet/SubtypeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/Ref",
	"csi/locale",
	"csi/xml"
], function(declare, csiHeading, Ref, locale, xml) {

	function _format(value) {
		return locale.resourceIfExists("SelectSetSubtype_" + value) || locale.type(value) || "";
	}

	return declare(Ref, {
		formatValue: _format,
		_toSortValue: _format,

		/**
		 * Return localized name (which is a type) rather than display name
		 */
		getNodeDisplayName: function(ctx, node) {
			return node ? _format(node.$Name) : "";
		},

		/**
		 * Use this renderer for formatting values rather than simple string renderer
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.ops = csiHeading.QUERY_OPS[xml.ATTR_REF];
			qs.ren = this;
			return qs;
		},

		/**
		 * @override
		 * Normally ref attributes resolve to the name of the referenced item, but in this case the
		 * name is formatted. So we need to ensure the value is in the store, whether it is queried
		 * or not.
		 */
		toHtmlQueryFilter: function(ctx, spec, refNode, params) {
			const {store, value} = params;

			if (value && store && !store.getFromMemory(value)) {
				store.addSelectedValue(value, _format(value));
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Return localized value
		 */
		formatValueForFiltering: function(ctx, h, value) {
			return _format(value);
		}

	});
});